export default {
  home: '首页',
  youthRregist: '青年竞演报名',
  carnivalRregist: '古镇嘉年华报名',
  mediaRegist: '媒体注册',
  listTheatreFestival: '乌镇戏剧节活动一览表',
  contactUs: '联系我们',
  supportUs: '支持我们',
  followUs: '关注我们',
  friendshipLink: '友情链接',
  introduce: '介绍',
  constitution: '章程',
  growth: '您可以通过以下方式联系我们，帮助我们茁壮成长：',
  specialthanks: '特别鸣谢名单',
  moreDates: '更多日期',
  performntroduction: '演出介绍',
  mediaCommentary: '媒体评论',
  editorIntroduction: '编剧介绍',
  directorIntroduction: '导演介绍',
  actorJobSchedule: '演员职表',
  troupeIntroduction: '剧团介绍',
  director: '导演',
  time: '时间',
  site: '场地',
  duration: '时长',
  generalPlanner: '总策划',
  brilliant: '璀璨国际',
  classicRefact: '经典重构',
  masterMaster: '大师佳作',
  fullSearch: '全站搜索',
  search: '搜索',
  searchHistory: '搜索记录',
  searchInfor: '请输入搜索信息',
  mediaRegist: '媒体注册',
  total: '共',
  items: '条',
  searchItems: '搜索信息',
  noData: '暂无数据',
  monday: '周一',
  tuesday: '周二',
  wednesday: '周三',
  thursday: '周四',
  friday: '周五',
  saturday: '周六',
  sunday: '周日',

  back: '返回',
  viewDetails: '查看详情',
  prevArticle: '上一篇',
  nextArticle: '下一篇',
  prevPage: '上一页',
  nextPage: '下一页',
  isFirst: '已是第一篇',
  isLast: '已是最后一篇',
  isFirstPage: '已是第一页',
  isLastPage: '已是最后一页',
  // 注册表
};
